const state = {
    globalSettings: [],
};

const getters = {
    getGlobalSettings: state => {
        return state.globalSettings;
    },
};

const mutations = {
    SET_GLOBAL_SETTINGS(state, payload) {
        state.globalSettings = payload;
    },
};

const actions = {
    async fetchGlobalSettings({ commit, getters }) {
        const response = await this._vm.$api.settings.getGlobalSettings();
        const globalSettings = response.data;
        commit('SET_GLOBAL_SETTINGS', globalSettings);
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
};
